// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"cc1a1bb1","262":"5717df10","395":"a9d74ffd","706":"90c7c3b5"}[chunkId] + ".chunk.js";
};